


































































































import { defineComponent, ref, useContext, computed, onMounted } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'
import { formatPrice } from '@/common/utils/numbers'
// import IconFa6SolidXmark from '~icons/fa6-solid/xmark'

import { useCountry } from '~/composables/country/useCountry'
import { usePriceBrick } from '~/composables/price-brick/usePriceBrick'
import { useI18n } from '~/composables/i18n'
import PriceBrickTableSkeleton from '@/components/global/skeletons/PriceBrickTableSkeleton.vue'
import PriceBrickFooter from '~/components/feature/price-brick/PriceBrickFooter.vue'
import { PriceBrickSkuData } from '~/types/product/productTypes'
// import { useVueModal } from '~/composables/ui/useVueModal'
import { usePdpStore } from '~/store/pdp'
export default defineComponent({
  components: {
    PriceBrickTableSkeleton,
    PriceBrickFooter,
    // IconFa6SolidXmark,
  },
  props: {
    skuData: {
      type: Array as () => PriceBrickSkuData[],
      required: true,
    },
    productId: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    productType: {
      type: String,
      required: false,
      default: null,
    },
    includeInventory: {
      type: Boolean,
      default: false,
    },
    customFormulationLabel: {
      type: String,
      required: false,
      default: null,
    },
    isCnDangerousProduct: {
      type: Boolean,
      required: false,
      default: false,
    },
    templateTitle: {
      type: String,
      required: false,
      default: null,
    },
  },
  emits: ['addToBasket'],
  setup(props, { emit }) {
    const { $config, $pim } = useContext()
    const { t } = useI18n()
    // const modal = useVueModal()
    const { setCanDisplayPriceBrick } = usePdpStore()
    const { canDisplayPriceBrick } = storeToRefs(usePdpStore())

    const { isCN, isBENELUX, isAU, isCA, isNZ, isFR, selectedCountry } = useCountry()
    const { addToBasketButtonText, showGetclpPrices, getCustomFormulationPath, mapGetclpResponseForPriceBrick } =
      usePriceBrick()

    const skus = ref(props.skuData)
    const checkedSku = ref(0)

    const hasNoSkuWithPrice = computed(() => !skus.value.length)
    // const cnDgProductInquiryUrl = computed(
    //   () =>
    //     `/learn-and-support/order-support/china-dg-product-inquiry?product_of_interest=${encodeURIComponent(
    //       props.productId + ' ' + props.productName
    //     )}&country=CN`
    // )

    onMounted(async () => {
      if (isCN.value) {
        setCanDisplayPriceBrick(false)
        const getclpData = await $pim.getProductAvailabilitiesAndPricing(props.productId, selectedCountry.value)
        skus.value = mapGetclpResponseForPriceBrick(getclpData, props.skuData)
        setCanDisplayPriceBrick(true)
      }
    })

    const onAddToBasket = () => {
      let trackAsOldPriceBrick = false

      if (isBENELUX.value) {
        window.open(`${$config.vendor.biokeApiHost}/cst/${props.productId}`, '_blank')
      } else if (isFR.value) {
        window.open(
          `${$config.vendor.ozymeApiHost}?page=1&_action=filter&criteria%5Bproperty%5D%5B392%5D%5B%5D=3197&q=CST${props.productId}`,
          '_blank'
        )
      } else if (isCA.value) {
        window.open(`${$config.vendor.nebCanadaApiHost}?query=${props.productId}&country=en-ca`, '_blank')
      } else if (isAU.value) {
        window.open(`${$config.vendor.nebAustraliaApiHost}?query=${props.productId}&country=en-au`, '_blank')
      } else if (isNZ.value) {
        window.open(`${$config.vendor.nebNewZealandApiHost}?query=${props.productId}&country=en-nz`, '_blank')
      } else if (isCN.value) {
        trackAsOldPriceBrick = true
        window.location.href =
          window.location.origin +
          '/learn-and-support/order-support/china-product-inquiry?country=cn&product_of_interest=' +
          encodeURIComponent(props.productId + ' ' + props.productName)
      } else {
        trackAsOldPriceBrick = true
        window.location.href =
          window.location.origin + `/product-information/local-information?productNo=${props.productId}`
      }
      emit('addToBasket', {
        items: [
          {
            id: props.productId,
            variant: props.productId,
            quantity: 1,
          },
        ],
        trackAsOldPriceBrick,
      })
    }

    const customFormulationPath = computed(() => getCustomFormulationPath(props.productId, props.productName))

    return {
      t,
      formatPrice,
      onAddToBasket,
      skus,
      customFormulationPath,
      addToBasketButtonText,
      showGetclpPrices,
      checkedSku,
      // cnDgProductInquiryUrl,
      canDisplayPriceBrick,
      hasNoSkuWithPrice,
    }
  },
})
